import { css } from "styled-components"
import { colors } from "../../helpers/colors"

interface ISectionWrapper {
  bgImg?: string
}

interface ISelectable {
  selected?: boolean
}

export const SectionWrapperStyles = css<ISectionWrapper>`
  display: flex;
  background-position: center top;
`
export const ContentWrapperStyles = css``
export const HeadingWrapperStyles = css``
export const DescriptionStyles = css``
export const CharactersWrapperStyles = css``
export const DetailsStyles = css`
  border: 1px solid ${colors.blue};
  background: radial-gradient(
    ellipse at center bottom,
    ${colors.categoriesBarGradientStart} 10%,
    ${colors.categoriesBarGradientEnd} 85%
  );
  margin-bottom: 80px;
`
export const SlideNumberStyles = css`
  color: ${colors.blue};
`
export const SlideStyles = css``
export const FeatureStyles = css``
export const FeatureImageStyles = css``
export const FeatureDescriptionStyles = css``
export const SkinStyles = css<ISelectable>`
  color: ${props => (props.selected ? colors.orange : `inherit`)};
  &:before {
    content: "◆";
    padding-right: 10px;
  }
  &:hover {
    color: ${colors.orange};
  }
`
export const ImagesStyles = css``
export const ImageStyles = css`
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 740px;
  & > img {
    position: absolute;
    bottom: 0;
    width: auto;
    max-width: 1050px;
  }
`
export const ThumbnailsStyles = css`
  align-items: center;
  margin-bottom: 80px;
`
export const ThumbnailStyles = css<ISelectable>`
  transform: rotate(-45deg);
  margin: -5px;
  filter: ${props => (props.selected ? `none` : `grayscale(.7)`)};
  &:nth-child(even) {
    margin-bottom: 120px;
  }
`
